import { z } from 'zod';
import { TimestampLike, safeText } from './common.js';

/**
 * How often a client's keywords are re-pulled. The scheduler runs daily
 * regardless; this is what performPull uses to advance `nextPullAt`, so it —
 * not the cron — is what actually sets cadence.
 */
export const TrackingFrequency = z.enum(['daily', 'weekly', 'monthly']);
export type TrackingFrequency = z.infer<typeof TrackingFrequency>;

export const ClientDoc = z.object({
  name: safeText('Client name', { max: 120 }),
  slug: z.string().min(1),
  assignedTo: z.string().min(1),
  trackingFrequency: TrackingFrequency.default('weekly'),
  isActive: z.boolean().default(true),
  createdAt: TimestampLike,
  createdBy: z.string().min(1),
  notes: z.string().optional(),
});
export type ClientDoc = z.infer<typeof ClientDoc>;
